import "../css/HomePage.css";
import "../css/LoginPage.css";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import {Helmet} from "react-helmet";
import ContactUsSection from "../components/ContactUsSection";
import PlansSection from "../components/PlansSection";
import SamplesSection from "../components/SamplesSection";
import WeblogSection from "../components/WeblogSection";
import AppDownloadSection from "../components/AppDownloadSection";
import colors from '../colors';


function HomePage() {
  
    const navigate = useNavigate();
    const token = JSON.parse(localStorage.getItem('userToken'));
    const config = {  headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`} };
    const [desktop, setDesktop] = useState(window.matchMedia("(min-width: 768px)").matches);
  
  
  


  return (
    <div>

{/* meta tags: ********************************************************************************************************/}
      <Helmet>
     
      <title>تولید محتوا با {process.env.REACT_APP_PROJECT_NAME}</title>
      <meta name="description" content={process.env.REACT_APP_PROJECT_NAME+ ' یه سرویس تولید محتوا سئو شده برای وبسایت هاست'}/>
      <meta name="robots" content="index, follow"/>
      <meta name="author" content={process.env.REACT_APP_PROJECT_NAME}/>
      <link rel="canonical" href={`${process.env.REACT_APP_SITE_URL}`}/>
      <meta property="og:title" content={process.env.REACT_APP_PROJECT_NAME}/>
      <meta property="og:description" content={process.env.REACT_APP_PROJECT_NAME+ ' یه سرویس تولید محتوا سئو شده برای وبسایت هاست'}/>
      <meta property="og:image" content={ require('../images/logo.png') }/>
      <meta property="og:url" content={`${process.env.REACT_APP_SITE_URL}`}/>
      <meta property="og:type" content="article"/>
      <meta property="article:published_time" content={"2024-11-28"}/>
      <meta property="article:author" content={process.env.REACT_APP_PROJECT_NAME}/>
      <meta name="twitter:card" content="summary_large_image"/>
      <script type="application/ld+json">
                  {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Article",
                    "headline": process.env.REACT_APP_PROJECT_NAME,
                    "description": process.env.REACT_APP_PROJECT_NAME+ ' یه سرویس تولید محتوا سئو شده برای وبسایت هاست',
                    "author": {
                      "@type": "Person",
                      "name": process.env.REACT_APP_PROJECT_NAME
                    },
                    "publisher": {
                      "@type": "Organization",
                      "name": process.env.REACT_APP_PROJECT_NAME,
                      "logo": {
                        "@type": "ImageObject",
                        "url": require('../images/logo.png') 
                      }
                    },
                    "datePublished":"2024-11-28"
                  })}
                </script>      
    </Helmet>
{/**********************************************************************************************************************/}


    
        





      <div className="top-box">
        <div className="login-pic">
          { desktop ? <img src={require("../images/homepage.png")} alt={process.env.REACT_APP_ALT}/> : <img src={require("../images/homepage.png")} alt={process.env.REACT_APP_ALT}/> }
        </div>

        <div className="info">
          <h1 className="title"> حرف به حرف : سئو خودکار، از حرف تا هدف!</h1>
          <p className="subtitle">
          {process.env.REACT_APP_PROJECT_NAME} یه سرویس تولید محتوا برای وبسایت ها است. کافیه شما فقط یه کلمه کلیدی انتخاب کنید، ما براتون یه مقاله کامل سئو شده به همراه عکس و لینک های خارجی می سازیم. روی عکس ها، واترمارک مخصوص خودتون قرار می گیره. تازه! برای هر مقاله، ما کلمه کلیدی های فرعی که تو سرچ گوگل پیشنهاد میشه رو هم بهتون نشون میدیم و روی این کلمه ها ، لینک سازی داخلی هم می کنیم!
          </p>
          <Link to="/register">
            <button>ثبت نام کنید، امتحان کنید!</button>
          </Link>
        </div>
      </div>


      <PlansSection/>
      

      <SamplesSection/>


      <ContactUsSection/>

      <WeblogSection/>

      <AppDownloadSection/>

      

      


    </div>
  );
}

export default HomePage;
